export const resources = {
  uk: {
    translation: {
      sign_in: {
        sign_in_with_google: 'Увійти за допомогою Google',
        sign_out: 'Вийти'
      },
      mission_reports: {
        add_new_report: 'Додати новий звіт'
      },
      mission_report: {
        title: 'Бойовий звіт',
        subtitle: 'Усі поля у цій формі обов’язкові для заповнення, окрім тих, де зазначено, що вони опціональні.',
        unit: 'Підрозділ',
        section_team: 'Екіпаж',
        section_uv: 'Борт',
        section_mission: 'Місія',
        section_payload: 'Корисне навантаження',
        section_result: 'Результат',
        attachments: 'Фото / Відео (за наявності)',
        uv_type: 'Тип борту',
        uvs_in_use: 'На позиції',
        uvs_other: 'Інші',
        uvs_empty: 'Список порожній',
        mission_date: 'Дата',
        team_name: 'Назва екіпажу',
        mission_number: 'Номер місії',
        team_position: 'Позиція екіпажу',
        commander_call_sign: 'Позивний командира екіпажу',
        operator_call_sign: 'Позивний пілота',
        mission_type: 'Тип місії',
        uv: 'Борт',
        other_uv: 'Борт',
        control_link_frequency: 'Частота каналу управління (за наявності)',
        video_link_frequency: "Частота каналу відеозв'язку (за наявності)",
        frequency_mhz: 'МГц',
        frequency_ghz: 'ГГц',
        battery_id: 'Номер акумулятора (за наявності)',
        mission_start_date: 'Дата початку',
        mission_start_time: 'Час початку',
        mission_end_date: 'Дата завершення',
        mission_end_time: 'Час завершення',
        target_code: 'Номер цілі',
        target_coordinates: 'Координати цілі у форматі MGRS',
        target_type: 'Характер цілі',
        payload_weight: 'Вага корисного навантаження, кг (за наявності)',
        travel_distance: 'Пройдена відстань, км (за наявності)',
        payload: 'БП',
        payload_1: '1 БП',
        payload_2: '2 БП',
        payload_3: '3 БП',
        payload_4: '4 БП',
        payload_count: 'Кількість',
        mission_status: 'Результат місії',
        mission_failure_reason: 'Причини неураження / обставини місії',
        mission_failure_reason_non_combat: 'Обставини місії',
        uv_condition: 'Стан борту після місії',
        uv_lost_reason: 'Причина втрати борту',
        uv_last_known_coordinates: 'Останні відомі координати борту (за наявності)',
        stream: 'Стрім',
        team_notes: 'Примітки екіпажу (необовʼязково)',
        create_mission_report: 'Створити звіт',
        successfully_created: 'Звіт успішно створено'
      },
      good_job_marine: {
        title: 'Так тримати, морпіх!',
        subtitle: 'Звіт створено та відправлено',
        add_new_report: 'Додати новий звіт'
      },
      qr_code_scanner: {
        scan_qr_code: 'Наведіть камеру на QR-код борта',
        qr_code_invalid: 'QR-код не містить правильного коду борта'
      },
      validations: {
        required: "Поле є обов'язковим",
        number: 'Значення повинно бути додатним числом',
        integer: 'Значення повинно бути додатним цілим числом',
        future_date: 'Дата / час не може бути в майбутньому',
        end_time_before_start: 'Час завершення повинен бути після часу початку',
        video_file: 'Будь ласка, завантажте відео чи фото',
        video_file_max_size: 'Розмір файлу не повинен перевищувати 95 МБ',
        video_upload_in_progress: 'Файл завантажується. Будь ласка, зачекайте',
        mgrs_format: 'Приклад: 35T PM 12345 67890',
        uv: 'Виберіть правильний код борта',
        correct_mission_status: 'Виберіть правильний результат місії',
        frequency_mhz_range: 'Частота повинна бути в діапазоні 50-999 МГц',
        frequency_ghz_range: 'Частота повинна бути в діапазоні 1.2-8.5 ГГц',
        failure_reason_invalid_for_damaged_uv: 'Причина не може бути "Все штатно" для пошкодженого борту',
        failure_reason_invalid_for_failed_mission: 'Причина не може бути "Все штатно" для неуспішної місії'
      },
      placeholders: {
        select: 'Оберіть',
        select_unit: 'Оберіть підрозділ',
        number: 'Введіть число',
        text: 'Введіть значення',
        date: 'Оберіть дату',
        file_upload: 'Завантажити файл',
        search: 'Почніть щось вводити',
        search_failure: 'Пошук не дав результатів',
        coordinates: 'Введіть координати у форматі MGRS',
        frequency_mhz_range: 'Введіть частоту в діапазоні 50-999 МГц',
        frequency_ghz_range: 'Введіть частоту в діапазоні 1.2-8.5 ГГц'
      },
      controls: {
        save: 'Зберегти',
        cancel: 'Скасувати',
        add: 'Додати',
        remove: 'Видалити',
        close: 'Закрити'
      },
      errors: {
        generic: {
          title: 'Помилка',
          message: 'Тут щось не те. Спробуйте оновити сторінку.'
        },
        generic_mutation: {
          title: 'Помилка',
          message: 'Тут щось не те. Спробуйте ще раз.'
        },
        access_denied: {
          title: 'Доступ заборонено',
          message: 'У вас немає дозволу на перегляд цієї сторінки.'
        },
        not_found: {
          title: 'Не знайдено',
          message: 'Сторінку не знайдено. Спробуйте перевірити URL.'
        },
        deprecated_payload: {
          message: 'Застосунок застарілий. Будь ласка, оновіть сторінку.',
          action: 'Оновити сторінку'
        }
      }
    }
  }
};
